export const boxWrapper = {
  marginLeft: '2px',
  marginRight: '10px',
  width: { xs: '68%', sm: '95%' },
}

export const datePickerBoxWrapper = {
  gap: '10px',
  display: 'flex',
  flexDirection: { xs: 'column', sm: 'row' },
  alignItems: { xs: 'stretch', sm: 'center' },
}
